<app-tabla
  [totalCount]="totalCount"
  [datos]="botonesBLE"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [emptyState]="{ title: 'Todavía no hay botones BLE' }"
></app-tabla>
